import { of } from 'rxjs';

export class TimerServiceStub {
  fetchServerTimeOffset() {
    return of(0);
  }
  serverTimeOffset: number = 0;
  setTimeout(fn: Function) {}
}
